import SmartLink from '../../lib/includes/components/component.smartlink';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import React from "react";

import LogoUrl from './../../assets/img/logo.svg';
import LogoUrlNegative from './../../assets/img/logo_negative.svg';
import Symbol from './../../assets/img/symbol_dark.svg';

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars, faXmark} from "@fortawesome/pro-light-svg-icons";

const Header = (props) => {
	if (!props.general) {
		return null;
	}

	let loginPage = props.general.header.login;
	let servicePage = props.general.header.service;

	let transHeader = props.headerStyle === 1 && !props.custom.scrolled && !props.custom.search_toggled;
	let solidHeader = props.headerStyle === 2;
	let pinned = props.custom.scrolled && !props.custom.search_toggled;

	return <header tabIndex={-1} className={"site-header" + (pinned ? " pinned" : "") + (transHeader ? " transparent" : "")  + (solidHeader ? " solid" : "")}>


		<a href="#content" className="skip-link">Till innehåll på sidan</a>

		<div className="site-header-bar">
			<div className="container">
				<div className="row align-items-center">
					<div className="col col-aside">
						<ul className="nav">
							<li className="nav-item">
								<button onClick={props.toggleMenu} className={"nav-link nav-link--menu-toggle " + (props.menu.menu_toggled ? " toggled" : "")}>
									<span></span>
									<span></span>
									<span></span>
								</button>
							</li>

							{props.general.header.quicklinks?.map((item, i) => {
								return <li key={i} className="nav-item nav-item--quicklink">
									<SmartLink url={item.link.url} className="nav-link">{item.link.title}</SmartLink>
								</li>
							})}

						</ul>
					</div>
					<div className="col col-logo">
						<Link to="/" className="logo">
							<img src={LogoUrl} className="default" alt={props.general.title} />
							<img src={LogoUrlNegative} className="negative" alt={props.general.title} />
						</Link>
					</div>
					<div className="col col-aside">


						<Link to={"/sok"} className={"search-toggle-mobile" + (props.custom.search_toggled ? " toggled" : "")} onClick={props.toggleSearch}><i className={"far fa-fw fa-" + (props.custom.search_toggled ? "times" : "search")}></i></Link>



						<ul className="nav nav-buttons">
							<li className="nav-item">
								<Link to={"/sok"} className={"nav-link"}><i className="icon far fa-search"></i>Sök</Link>
							</li>
							{loginPage &&
								<li className="nav-item">
									<SmartLink url={loginPage.url} target={loginPage.target} className={"button button-sm" + (transHeader ? " button-light-outline" : "")}><i className="icon far fa-user-alt"></i><span className="button-text">{loginPage.title}</span></SmartLink>
								</li>
							}

						</ul>

					</div>
				</div>
			</div>
		</div>


		<div tabIndex="-1" className={"site-navigation" + (props.menu.menu_toggled ? " open" : "")}>
			<div className="site-navigation-dialog">

				<button className="menu-close" onClick={props.toggleMenu} onKeyDown={(e) => props.focusBottom(e)}><i className="icon fal fa-fw fa-times"></i><span className="">Stäng</span></button>


				{props.menu.menus.main_menu &&
					<ul className="nav">
						{props.menu.menus.main_menu.items.map((item, i) => {
							if (item.parent === 0) {
								let children = props.menu.menus.main_menu.items.filter(it => it.parent === item.id);
								if (children.length > 0) {

									let toggled = props.custom.submenu_id?.includes(item.id);

									return <li key={item.id} className={"nav-item has-children" + (toggled ? " open" : "")}>
										<button onClick={props.toggleSubMenu.bind(null, item.id)} className="nav-link" aria-expanded={toggled} aria-controls={"sub-" + item.id}>{item.title}</button>

										<div id={"sub-" + item.id} className="sub-menu" aria-hidden={!toggled}>
											<div className="sub-menu-inner">
												<ul className="nav nav-sub">
													{children.map((subitem, i) => {
														return <li key={i} className={"nav-item" + (subitem.class ? " " + subitem.class : "")}>
															<SmartLink className="nav-link" url={subitem.url} target={subitem.target}>{subitem.title}</SmartLink>
														</li>
													})}
												</ul>
											</div>
										</div>

									</li>

								} else {

									return <li key={item.id} className="nav-item">
										<SmartLink activeClassName="current" className="nav-link" url={item.url} target={item.target}>{item.title}</SmartLink>
									</li>
								}
							}
						})}
					</ul>
				}

				{loginPage &&
					<SmartLink url={loginPage.url} target={loginPage.target} className="button button-lg button-dark mt-auto"><i className="far fa-user-alt me-1"></i> {loginPage.title}</SmartLink>
				}

				{servicePage &&
					<SmartLink url={servicePage.url} target={servicePage.target} className="button button-lg button-oh mt-3"><i className="far fa-comments-alt me-1"></i> {servicePage.title}</SmartLink>
				}


				<button className="menu-close-button" onClick={props.toggleMenu} onKeyDown={(e) => props.focusTop(e)}>
					<i className="far fa-fw fa-times"></i> Stäng
				</button>

			</div>

			<div className="site-navigation-bg" onClick={props.toggleMenu}></div>

		</div>

	</header>
};
export default connect(
	state => {
		return {
			menu: state.menuState,
			general: state.generalState.general,
			headerStyle: state.pageState.page?.headerStyle,
			custom: state.customState
		}
	},
	(dispatch) => {
		return {
			toggleMenu: () => {
				dispatch({
					type: 'MENU_TOGGLED'
				})

				body.classList.toggle("scroll-locked");

				setTimeout(() => {
					document.querySelector(".site-navigation")?.focus();
				}, 100)

			},
			toggleSubMenu: (id, e) => {

				e.preventDefault();
				dispatch({
					type: 'SUBMENU_TOGGLED',
					id: id
				})

			},
			focusTop: (event) => {
				if (event.key === 'Tab') {
					if (!event.shiftKey) {
						event.preventDefault();
						document.querySelector(".menu-close")?.focus();
					}
				}
			},
			focusBottom: (event) => {
				if (event.key === 'Tab') {
					if (event.shiftKey) {
						event.preventDefault();
						document.querySelector(".menu-close-button")?.focus();
					}
				}
			},
		}
	}
)(Header);
